<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} свойства </v-toolbar>
      <comp-property-card :property="localProperty" :mode="'editor'" :full-view="true" @onPropUpdate="doPropUpdate"/>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark :disabled="saveDisabled" @click="doSave" outlined>
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompPropertyCard from '@/components/modules/projects/cards/configuration/compPropertyCard'
import axios from 'axios'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'prjAddProjectPropertyDialog',
  components: { CompPropertyCard },
  props: ['property', 'project', 'value'],
  data () {
    return {
      localProperty: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавить' : 'Сохранить' : ''
      }
    },
    hdrText: {
      get () {
        return this.localProperty ? this.dataNew ? 'Добавление' : 'Редактирование' : ''
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localProperty) return true
        const noMin = !this.localProperty.PROP_MIN
        const noMax = !this.localProperty.PROP_MAX
        return noMin || noMax || !this.dataChanged
      }
    },
    dataChanged: {
      get () {
        if (this.dataNew) return true
        return this.property[0].PROP_ID !== this.localProperty.PROP_ID || this.property[0].PROP_MIN !== this.localProperty.PROP_MIN || this.property[0].PROP_MAX !== this.localProperty.PROP_MAX || this.property[0].PROP_KOEFF !== this.localProperty.PROP_KOEFF
      }
    },
    dataNew: {
      get: function () {
        console.log('Requested for dataNew. Initial property is ', this.property, '. Local property is ', this.localProperty)
        return !this.property.length
      }
    }
  },
  watch: {
    property (val) {
      console.log('prjAddProjectPropertyDialog watcher property detected change to ', val)
      if (val && val.length) {
        console.log('val length is more than 0')
        // eslint-disable-next-line no-undef
        this.localProperty = structuredClone(this.property[0])
      } else {
        console.log('val length is 0')
        this.localProperty = {}
      }
      console.log('Current lP is ', this.localProperty)
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.dataNew ? 'add' : 'update'
      const processorPath = action === 'update' ? '/api/org/receptures/rcptUpdRcptProperty.php' : '/api/org/receptures/rcptAddRcptProperty.php'
      const payload = { ...this.localProperty }
      payload.PROP_KOEFF = this.localProperty.PROP_KOEFF || 1
      payload.ULF_ID = this.project.ULF_ID
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('propertyAdded', [resp.data.data])
            } else {
              self.$emit('propertyUpdate', [resp.data.data])
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doPropUpdate (data) {
      console.log('prjAddProjectPropertyDialog:: doPropUpdate method called ', data)
      this.localProperty = { ...this.localProperty, ...data }
      console.log('prjAddProjectPropertyDialog:: doPropUpdate current data is ', this.localProperty)
    }
  },
  mounted () {
    console.log('prjAddProjectPropertyDialog mounted with property ', this.property)
  }
}
</script>
